/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { Skeleton, Stack } from '@mui/material';
import { FC } from 'react';

const ProfileAvatarSkeleton: FC = () => <Skeleton variant="circular" width={33} height={33} />;

const ProfileInfoSkeleton: FC = () => (
  <Stack direction="column">
    <Skeleton width={90} height={18} />
    <Skeleton width={120} height={12} />
  </Stack>
);

export { ProfileAvatarSkeleton, ProfileInfoSkeleton };
